// @flow
import React from 'react';
import {Dropdown} from '@homeaway/react-dropdown';
import Tooltip from '@homeaway/react-tooltip';
import './InternalTools.less';
import gql from 'graphql-tag';
import {isAbsoluteURL} from '../../utils/routerUtils';

export const fragments = {
    SearchResult: gql`
        fragment InternalToolsSearchResult on SearchResult {
            internalTools {
                searchServiceUrl
            }
        }
    `
};

export type InternalToolsType = {
    searchServiceUrl?: string
};

type Props = {
    searchServiceUrl?: string,
    graphiqlUrl?: string,
    environment?: string
};

const urls = {
    production:
        'http://searchv2-service-flex-production.us-east-1-vpc-d9087bbe.slb.prod.aws.away.black',
    stage:
        'http://searchv2-service-flex-stage.us-east-1-vpc-35196a52.slb.stage.aws.away.black',
    test:
        'http://searchv2-service-flex-test.us-east-1-vpc-88394aef.slb.test.aws.away.black',
    development:
        'http://searchv2-service-flex-stage.us-east-1-vpc-35196a52.slb.stage.aws.away.black'
};

const clipboardQuery = () => {
    if (document && document.body) {
        const textArea = document.createElement('textarea');
        textArea.value = window.__GRAPHQL_QUERY__;
        // $FlowFixMe
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        // $FlowFixMe
        document.body.removeChild(textArea);
    }
};

const InternalTools = ({searchServiceUrl, graphiqlUrl, environment}: Props) => {
    let searchServiceLink;

    const parentNode =
        typeof window !== 'undefined'
            ? document.querySelector('.site-header')
            : null;

    if (searchServiceUrl) {
        const regionSearchServiceUrl = urls[environment || 'stage'];
        const delim = searchServiceUrl.indexOf('/') === 0 ? '' : '/';
        searchServiceLink = isAbsoluteURL(searchServiceUrl)
            ? searchServiceUrl
            : `${regionSearchServiceUrl}${delim}${searchServiceUrl}`;
    }

    return (
        <Dropdown
            id="internalTools"
            label=""
            buttonChildren={
                <span className="InternalTools__buttonText text-link">
                    {'Internal Tools'}
                </span>
            }
            className="InternalTools"
        >
            {searchServiceLink && (
                <li
                    className="InternalTools__SearchServiceUrl"
                    role="presentation"
                >
                    <a href={searchServiceLink} target="_blank">
                        {'Search Service Url'}
                    </a>
                </li>
            )}
            {graphiqlUrl && (
                <li
                    className="InternalTools__GraphiqlUrl"
                    onClick={clipboardQuery}
                    role="presentation"
                >
                    <Tooltip
                        content="Paste graphql query into query block in opened tab"
                        parentNode={parentNode}
                        placement="bottom"
                        tooltipType="popover"
                        wrapperClassName="InternalTools__Tooltip"
                    >
                        <a
                            className="InternalTools__Link"
                            href={graphiqlUrl}
                            target="_blank"
                        >
                            {'GraphiQl URL'}
                        </a>
                    </Tooltip>
                </li>
            )}
        </Dropdown>
    );
};

export default InternalTools;
